import Dashboard from 'presentation/components/Dashboard';
import KSHeader from 'presentation/components/KSHeader';
import { useIsMobile } from 'hooks/useIsMobile';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function DashboardViewNew(): JSX.Element {
  const isMobile = useIsMobile();
  const { enableQueueV2 } = useFlags();

  // Hide KSHeader on mobile when KSQ2 layout is enabled
  // MobileKSQ2Layout has its own header with location selector
  const showKSHeader = !(isMobile && enableQueueV2);

  return (
    <div className="dashboard-view">
      {showKSHeader && <KSHeader />}
      <Dashboard />
    </div>
  );
}
